module.exports = __webpack_public_path__ + "img/1-08.933976b0.svg";